import {Component} from "react";
import {IActionBase} from "./IActionBase";
import {ActionsManager} from "./actionsManager";
import {store} from "../../redux/storeConfig/store";
import {callPostService} from "../services/api_service";
import {webResponseObject} from "../services/webResponseResponse";
import {utils_ui} from "../utils/utils_ui";
import {dataUtils} from "../js/dataUtils";
import {cloneDeep} from "lodash";
import {differenceInMilliseconds} from "date-fns";

internals: {
    let lstStartModes = [
        { value: 'lock', text: 'Lock' },
        { value: 'unlock', text: 'Unlock' },
    ]
}

let Modes = {
    lock: 'lock',
    unlock: 'unlock'
}

export class action_AP_LockUnlockElements extends Component implements IActionBase {
    actionCode = "action_AP_LockUnlockElements";
    actionName = "Lock / Unlock UI Elements";

    Execute = (prmActionParameters: any, prmActionsManager: ActionsManager, prmElementObj?: any) => {

        //const timerId = setTimeout(() => {
                let runtimeMode = utils_ui.getDataItem(prmActionParameters.DataBindStr);

                let arrRelatedElements:any = [];
                let arrIncludeElementTags:any = [];
                let arrExcludeElementTags:any = [];

                if (!!prmActionParameters.IncludeElementTags) {
                    arrIncludeElementTags = prmActionParameters.IncludeElementTags.split(",");
                }

                if (!!prmActionParameters.ExcludeElementTags) {
                    arrExcludeElementTags = prmActionParameters.ExcludeElementTags.split(",");
                }

                const pageStructure: any = store.getState().store_PageStructure.pageStructure
                const lstPageElements = pageStructure?.LstPageElements

                if (!!lstPageElements) {

                    arrRelatedElements = lstPageElements.filter((prmItem:any) => {
                        let outVal = false;
                        let arrElementTags = [];

                        if (!!prmItem.ElementTags) {
                            arrElementTags = prmItem.ElementTags.split(",");
                        }

                        if (!prmActionParameters.IncludeElementTags) {
                            outVal = true;
                        }
                        else {
                            for (const currElementTags of arrIncludeElementTags) {
                                if (arrElementTags.indexOf(currElementTags) > -1) {
                                    outVal = true;
                                    break;
                                }
                            }
                        }

                        if (!!prmActionParameters.ExcludeElementTags) {
                            for (const currElementTags of arrExcludeElementTags) {
                                if (arrElementTags.indexOf(currElementTags) > -1) {
                                    outVal = false;
                                    break;
                                }
                            }
                        }

                        return outVal;
                    });
                }


                let valueIsReadOnly:boolean = false
                if (!runtimeMode || runtimeMode == Modes.lock) {
                    valueIsReadOnly = true;
                    utils_ui.setDataItem(prmActionParameters.DataBindStr, Modes.unlock);
                }
                else if (!!prmActionParameters.IsUnlockAllowed) {
                    valueIsReadOnly = false;
                    utils_ui.setDataItem(prmActionParameters.DataBindStr, Modes.lock);
                }

                let lstModifiedElements:any = []
                let dicFlatElements = store.getState().store_PageStructure.dicElementsFlatTree

                for (const currElementObj of arrRelatedElements) {
                    let currElement = {...dicFlatElements[currElementObj.ElementGuid]}

                    if (!!currElement) {
                        currElement.ElementObj.IsReadOnly = valueIsReadOnly
                        lstModifiedElements.push(currElement)
                    }

                    //store.dispatch({type: 'CHANGE_ELEMENT', CurrElement: currElement})
                }

                store.dispatch({type: 'CHANGE_MULTIPLE_ELEMENTS', lstModifiedElements: lstModifiedElements})

            //     clearTimeout(timerId)
            // }
            // , 500)

        // let latestPageInfo = store.getState().store_PageStructure?.latestPageInfo
        // let lstPageParameters = latestPageInfo?.PageProperties?.LstPageParameters
        // let runtimeMode = lstPageParameters?.find((prmParameter:any) => {
        //     return prmParameter?.ParamName == this.ParamName
        // })?.ActualValue

    }
}